import { Checkbox, FormControlLabel, FormGroup, Stack } from "@mui/material";
import { isManualActionIncentivationSourceModel, ManualActionIncentivationSourceModel } from "../../../../types/actionModule/incentivationSource/incentivationSourceModel";
import { useCallback } from "react";
import { IncentivationSourceEditorProps } from "../../../../types/actionModule/editor/incentivationSourceEditorTypes";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";


export default function ManualActionIncentivationSourceEditor(props: IncentivationSourceEditorProps) {
    const { t } = useTranslation();

    const incentivationSource = props.value;

    if(!isManualActionIncentivationSourceModel(incentivationSource)) {
        return <>Invalid value</>
    }

    return InnerManualActionIncentivationSourceEditor(props, incentivationSource, t);
}

function InnerManualActionIncentivationSourceEditor(props: IncentivationSourceEditorProps, incentivationSource: ManualActionIncentivationSourceModel, t: TFunction<"translation", undefined>) {
    const onChanged = useCallback(
        (value: ManualActionIncentivationSourceModel) => props.onChanged(value),
        [props.onChanged]
    );

    return <Stack>
        <FormGroup>
            <FormControlLabel
                control={<Checkbox
                    checked={incentivationSource.canBulkUploadIncentivationData}
                    onChange={(e) => onChanged({
                        ...incentivationSource,
                        canBulkUploadIncentivationData: e.target.checked,
                    })} />}
                label={t("actionModules.incentivationSource.manualAction.canBulkUpload")} />
            <FormControlLabel
                control={<Checkbox
                    checked={incentivationSource.canBeCompletedByEmployeeUser}
                    onChange={(e) => onChanged({
                        ...incentivationSource,
                        canBeCompletedByEmployeeUser: e.target.checked,
                    })} />}
                label={t("actionModules.incentivationSource.manualAction.canBeCompletedByEmployee")} />
        </FormGroup>
    </Stack>;
}
